/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MenuComponent } from '../../../assets/ts/components';
import Select from 'react-select';
import { KTSVG, SimpleAlert, toAbsoluteUrl } from '../../../helpers';
import { useLayout } from '../../core';
import { Header } from './Header';
import { Topbar } from './Topbar';
import { ThemeToggle } from '../../../../app/components/ThemeToggle';
import { useObtenerEventosSelect } from '../../../../app/pages/eventos/hooks/EventosHook';
import { styleSelect, themeSelect } from '../../../assets/ts/_utils';
import { actualEventoService } from '../../../../app/service/eventos/Eventos';

export function HeaderWrapper() {
  const { pathname } = useLocation();
  const { config, classes, attributes } = useLayout();
  const [reload, setReload] = useState<number>(Math.random() * 40);
  const { list, loading } = useObtenerEventosSelect(reload);
  const { header, aside } = config;
  const eventoActual = list.find((evento) => evento.actual);
  const nombreEvento = eventoActual?.data?.nombre ?? 'Ticket Cash';

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [pathname]);

  const handleOnChange = async (selectedOption: any) => {
    try {
      if (selectedOption) {
        const { id } = selectedOption;
        await actualEventoService(id);
        window.location.reload();
      }
    } catch (error: any) {
      if (error && error.response) {
        const { message } = error.response.data;
        SimpleAlert(message, 3000, 'error');
      }
    }
  };

  return (
    <>
    <Helmet>
      <title>{nombreEvento}</title>
    </Helmet>
    <div
      id="kt_header"
      className={clsx(
        'header',
        classes.header.join(' '),
        'align-items-stretch'
      )}
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div
            className="d-flex align-items-center d-lg-none ms-n3 me-1"
            title="Show aside menu"
          >
            <div
              className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
              id="kt_aside_mobile_toggle"
            >
              <KTSVG
                path="/media/icons/duotune/abstract/abs015.svg"
                className="svg-icon-2x mt-1"
              />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}
        {/* begin::Logo */}
        {!aside.display && (
          <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
            <Link to="/dashboard" className="d-lg-none">
              <img
                alt="Logo"
                src={toAbsoluteUrl('/media/logos/favicon.png')}
                className="h-30px"
              />
            </Link>
          </div>
        )}
        {/* end::Logo */}

        {aside.display && (
          <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
            <Link to="/" className="d-lg-none">
              <img
                alt="Logo"
                src={toAbsoluteUrl('/media/logos/favicon.png')}
                className="h-30px"
              />
            </Link>
          </div>
        )}

        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <div className="d-flex align-items-center" id="kt_header_nav">
            <h1 className="text-white fw-bolder my-1 fs-3">{nombreEvento}</h1>
          </div>

          <div className="d-flex align-items-center ms-auto" id="kt_header_nav">
            <h1 className="text-white fw-bolder my-1 fs-3 me-5">Evento:</h1>
            <span>
              <Select
                options={list}
                className="w-300px"
                value={list.find((evento) => evento.actual) || null}
                styles={styleSelect}
                theme={themeSelect}
                classNamePrefix="tc-select"
                placeholder={'Seleccione'}
                isSearchable={true}
                noOptionsMessage={() => {
                  return <span>{'No se encontraron eventos'}</span>;
                }}
                isLoading={loading}
                onChange={handleOnChange}
                backspaceRemovesValue
              />
            </span>
          </div>

          {header.left === 'menu' && (
            <div className="d-flex align-items-stretch" id="kt_header_nav">
              <Header />
            </div>
          )}

          <div className="d-flex align-items-stretch flex-shrink-0 align-items-center">
            <ThemeToggle />
            <Topbar />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
